// import AssistivLogo from '@/assets/branding/assistiv/assistiv-logo.png';
import { AssistivLogoSVG } from '@/assets/branding/assistiv';

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AssistivLogoSVG,
  colors: {
    // Brand colors
    brand_primary: '#0779FF', // '#e4e7ed', // '#FF5733',
    brand_primary_hover: '#175CD3',
    brand_primary_highlight: '#84CAFF',
    brand_primary_mid: '#1C86FF',
    brand_primary_dark: '#043E80',
    brand_secondary: '#2F6CCE',
  },
};
